// extracted by mini-css-extract-plugin
export var cell = "_6l-4";
export var headerCell = "_6l-2";
export var rowHeader = "_6l-3";
export var table = "_6l-1";
export var tableContainer = "_6l-0";